import NursingVentilationService from '@/services/nursingventilation.service';

const state = {
};

/* eslint-disable no-param-reassign */
const mutations = {
};

const actions = {
  fetchList({}, param = {}) {
    // TODO: chan - should get vaps on backend
    return NursingVentilationService.list(param)
      .then((response) => {
        return response;
      });
  },
  fetchListByGroup({}, payload) {
    return NursingVentilationService.listByGroup(payload)
      .then((response) => {
        return response;
      });
  },
  addItem({}, payload) {
    return NursingVentilationService.create(payload)
      .then((response) => {
        return response;
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};